var map = {
  "./check-icon.svg": "986504",
  "./custom-export-360-fullcontent.svg": "679013",
  "./custom-export-by_reviewee.svg": "599189",
  "./custom-export-by_reviewer.svg": "443418",
  "./custom-export-objectives-by_objective.svg": "84359",
  "./custom-export-objectives-by_user.svg": "306551",
  "./custom-export-objectives-fullcontent.svg": "643194",
  "./loading-spinner.svg": "716062",
  "./module-reviews-icon.svg": "739832",
  "./move-objective-icon.svg": "694839",
  "./plus.svg": "615426"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 222000;
